<template>
    <div>
        <Loader v-if="loading"/>
        <div v-else-if="filteredAisCompanyLogs && filteredAisCompanyLogs.length > 0" class="pa-5">
            <div v-for="item in filteredAisCompanyLogs" :key="item.id">
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Log ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.id ? item.id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Company bank ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.company_bank_id ? item.company_bank_id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Bank ID" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.bank_id ? item.bank_id : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Bank name" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.bank_name ? item.bank_name : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Bank swift" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.bank_swift ? item.bank_swift : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Event at" | t }}</v-col>
                    <v-col class="col-item" cols="9" :class="{'error-row': item.action && item.action === 'error'}">
                        {{ item.event_at ? tz(item.event_at) : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Action" | t }}</v-col>
                    <v-col class="col-item" cols="9" :class="{'error-row': item.action && item.action === 'error'}">
                        {{ item.action ? item.action : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Message" | t }}</v-col>
                    <v-col class="col-item" cols="9" :class="{'error-row': item.action && item.action === 'error'}">
                        {{ item.message ? item.message : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "Data" | t }}</v-col>
                    <v-col class="col-item" cols="9" :class="{'error-row': item.action && item.action === 'error'}">
                        {{ item.data ? item.data : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "IP" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.user_ip ? item.user_ip : "-" }}
                    </v-col>
                </v-row>
                <v-row>
                    <v-col class="col-item row-title" cols="3">{{ "User agent" | t }}</v-col>
                    <v-col class="col-item" cols="9">
                        {{ item.user_agent ? item.user_agent : "-" }}
                    </v-col>
                </v-row>
                <v-divider class="mb-3 mt-3"/>
            </div>
        </div>
        <div v-else class="pa-5 text-center">{{ "No data" | t }}</div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import Loader from "@/components/Loader";

export default {
    name: "consent-ais-company-logs-tab",
    components: {Loader},
    props: ['loading'],
    computed: {
        ...mapState('ais', ['aisCompanyLogs', 'activeLogSwift']),
        filteredAisCompanyLogs: function () {
            if (this.aisCompanyLogs) {
                return this.aisCompanyLogs;
            }
            return [];
        }
    },
}
</script>

<style scoped>
.row-title {
    color: gray;
}

.col-item {
    padding-top: 2px;
    padding-bottom: 2px;
}
.error-row {
    color: red;
}
</style>